import { forwardRef, PropsWithChildren, HTMLAttributes } from 'react';
import type { SxProps } from '@mui/material';

import { StyledTitle } from './Title.style';

type TitleProps = {
  sx?: SxProps;
} & HTMLAttributes<HTMLHeadingElement>;

const Title = forwardRef<HTMLHeadingElement, PropsWithChildren<TitleProps>>(
  ({ children, ...rest }, ref) => (
    <StyledTitle ref={ref} {...rest}>
      {children}
    </StyledTitle>
  )
);

export default Title;
